import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';
import React from 'react';
import { RoleListContainer } from '../components/role-list-container';
import { SubPageLayout } from '../sub-page-layout';

interface RoleListProps {}

export const RoleList: React.FC<RoleListProps> = (_props) => {
  return (
    <SubPageLayout
      header={<PageHeader title={<Typography.Title className="staff-title"> Roles</Typography.Title>} />}
    >
      <div className="w-full flex justify-between flex-col text-left">
        <div className="flex items-center w-full justify-between"></div>
        <div className="flex">
          <div className="mr-[150px] w-[10%]"></div>
          <div className="w-full flex justify-between flex-col text-left">
            <RoleListContainer filters={null}/>
          </div>
        </div>
      </div>
    </SubPageLayout>
  );
};
